import {OtsUIState} from "../../ots-ui-store";

export const selectUIDVIRSearchFilter = (state: OtsUIState) => state.uiDVIR.searchFilter
